if (!customElements.get('product-recommendation')) {
  customElements.define('product-recommendation', class ProductRecommendation extends HTMLElement {
    static observedAttributes = ['data-filter-color', 'data-collection'];

    constructor() {
      super();
      this.data = '';
      this.url = '';
    }

    async connectedCallback() {
      if (this.dataset.collection === '') return;

      const url = new URL(this.dataset.collection);
      url.searchParams.set('sections', 'render-recommendation');
      url.searchParams.set('filter.p.m.attribute.colour_for_filtering', this.dataset.filterColor);
      this.url = url;

      await this.fetchData(this.url);
      await this.render();
    }

    async attributeChangedCallback(name, oldValue, newValue) {
      if (oldValue === null) return;

      if (name === 'data-collection') {
        this.url = new URL(this.dataset.collection);
        this.url.searchParams.set('sections', 'render-recommendation');
        this.url.searchParams.set('filter.p.m.attribute.colour_for_filtering', this.dataset.filterColor);
      }

      if (name === 'data-filter-color' && this.url) {
        this.url.searchParams.set('filter.p.m.attribute.colour_for_filtering', newValue);
      }

      await this.fetchData(this.url);
      await this.render();
    }

    async render() {
      this.innerHTML = this.data;

      this.disableSecondaryTitle();

      EasySelect.init('[data-easy-select]:not(:empty)', {
        align: 'top'
      });

      Array.from(this.querySelectorAll('select[name="id"]')).forEach((el) => {
        this.toggleNonMagSafeForm(el);
      });

      Array.from(this.querySelectorAll('select[name="id"]')).forEach((el) => {
        el.addEventListener('change', (e) => {
          const select = e.target;
          const productCard = select.closest('.product-recommendation');

          if (!productCard) return;

          const image = productCard.querySelector('img');
          const selectedOption = select.selectedOptions[0];

          if (image && selectedOption?.dataset.imgUrl) {
            image.removeAttribute('srcset');
            image.src = selectedOption.dataset.imgUrl;
          }

          this.toggleNonMagSafeForm(select);
        });
      });

      Array.from(this.querySelectorAll('[data-filter-group-param]')).forEach((el) => {
        el.addEventListener('change', (e) => {
          this.url.searchParams.set(e.target.dataset.filterGroupParam, decodeURIComponent(e.target.value));
          this.dataset.collection = decodeURIComponent(this.url.toString());
        });
      });
    }

    async fetchData(url) {
      console.log(`fetching recommendations from ${url}`);
      const response = await fetch(url);
      const json = await response.json();
      const parser = new DOMParser();
      const html = parser.parseFromString(json['render-recommendation'], 'text/html');
      this.data = html.getElementById('shopify-section-render-recommendation').innerHTML;
    }

    toggleNonMagSafeForm(el) {
      const productCard = el.closest('.product-recommendation');
      if (!productCard) return;

      const selectedOption = el.selectedOptions[0];
      if (!selectedOption) return;

      const nonMagSafeForm = productCard.querySelector('[data-variants]');

      if (nonMagSafeForm) {
        const data = JSON.parse(atob(nonMagSafeForm.dataset.variants));
        const nonMagSafeItem = data.find((item) => item.color === selectedOption.label);

        if (nonMagSafeItem && nonMagSafeItem.available) {
          if (nonMagSafeForm.elements.id) {
            nonMagSafeForm.elements.id.value = nonMagSafeItem.variant;
          }
          nonMagSafeForm.classList.remove('hidden');
          if (nonMagSafeForm.closest('div')) {
            nonMagSafeForm.closest('div').classList.add('grid', 'grid-cols-2');
          }
        } else {
          nonMagSafeForm.classList.add('hidden');
          if (nonMagSafeForm.closest('div')) {
            nonMagSafeForm.closest('div').classList.remove('grid', 'grid-cols-2');
          }
        }
      }

      const variantAvailable = selectedOption.dataset.available === 'true';

      const localForm = productCard.querySelector('.product-form form');
      const localFormId = localForm ? localForm.getAttribute('id') : null;

      let addToCartBtn = null;
      if (localFormId) {
        addToCartBtn = productCard.querySelector(`[type="submit"][form="${localFormId}"]`);
      }

      if (!addToCartBtn) {
        addToCartBtn = productCard.querySelector('[type="submit"]');
      }

      if (addToCartBtn) {
        const btnText = addToCartBtn.querySelector('span') || addToCartBtn;

        if (variantAvailable) {
          btnText.innerText = addToCartBtn.dataset.translationAddToCart || 'Add to cart';
          addToCartBtn.disabled = false;
          addToCartBtn.classList.remove('sold-out', 'is-sold-out');
          addToCartBtn.removeAttribute('aria-disabled');
        } else {
          btnText.innerText = addToCartBtn.dataset.translationSoldOut || 'Sold out';
          addToCartBtn.disabled = true;
          addToCartBtn.classList.add('sold-out', 'is-sold-out');
          addToCartBtn.setAttribute('aria-disabled', 'true');
        }
      }

      const image = productCard.querySelector('img');
      if (image && selectedOption.dataset.imgUrl) {
        image.removeAttribute('srcset');
        if (image.src !== selectedOption.dataset.imgUrl) {
          image.src = selectedOption.dataset.imgUrl;
        }
      }
    }

    disableSecondaryTitle() {
      const recommendationHasParentTypes = this.dataset.recommendationsContainsParentTypes === 'true';

      if (!recommendationHasParentTypes) {
        const titleEl = this.querySelector('.product-recommendation__group-title span');
        if (titleEl) {
          titleEl.remove();
        }
      }
    }
  });
}